import { Dispatch } from 'react';

import { NavigateFunction } from 'react-router-dom';

import { AnyAction } from 'redux';

import { setWorkflowFeedback } from 'common/store/reducer/simulationReducer';

import {
	Grid,
	styles,
	Typography,
	toSentenceCase,
	NO_DATA_FOUND,
	dateInCorrectFormatWithFullYear,
	HTTP_STATUS_CODES,
	getAiRecipePath,
	getRoutePathForModel,
	callAISimulationDeleteModelsData,
	callAISimulationDeleteRecipesData,
	updateSharedSimulationOnDelete,
	IAIModelDetails,
	IAIRecipeDetails,
	APP_GENERAL_ERROR_MSG,
	APP_GENERIC_BAD_REQUEST_MSG,
	setAIRecipeDetail,
	AI_TYPE,
	setAIModelDetail,
} from 'features/AiSimulation/SimulationArena/SimulationArenaModules';

const { RECIPE } = AI_TYPE;
const { OK } = HTTP_STATUS_CODES;

const deleteSharedResponse = async (
	rowId: string,
	completionHandler: (isAPICallSuccess: boolean, errorMessage: string) => void,
) => {
	const deleteSharedData = await updateSharedSimulationOnDelete(rowId);
	if (deleteSharedData?.statusCode !== OK) {
		completionHandler(false, APP_GENERAL_ERROR_MSG);
	} else {
		completionHandler(true, 'The simulation was deleted successfully');
	}
};

export const onClickDeleteHandler = async (
	rowData: any,
	type: any,
	completionHandler: (isAPICallSuccess: boolean, errorMessage: string) => void,
) => {
	if (type === RECIPE) {
		const responseFromApi = await callAISimulationDeleteRecipesData(rowData.id);

		if (responseFromApi?.responseBody && responseFromApi?.statusCode === OK) {
			deleteSharedResponse(rowData.id, completionHandler);
			completionHandler(true, '');
		} else {
			completionHandler(false, APP_GENERIC_BAD_REQUEST_MSG);
		}
	} else {
		const responseFromApi = await callAISimulationDeleteModelsData(rowData.id);

		if (responseFromApi?.responseBody && responseFromApi?.statusCode === OK) {
			deleteSharedResponse(rowData.id, completionHandler);
			completionHandler(true, '');
		} else {
			completionHandler(false, APP_GENERIC_BAD_REQUEST_MSG);
		}
	}
};

export const onClickEditHandler = (
	paramData: any,
	type: any,
	dispatch: Dispatch<AnyAction>,
	navigate: NavigateFunction,
) => {
	dispatch(setWorkflowFeedback([]));
	if (type === RECIPE) {
		dispatch(setAIRecipeDetail(paramData as IAIRecipeDetails));
		navigate(getAiRecipePath(paramData.models));
	} else {
		dispatch(setAIModelDetail(paramData as IAIModelDetails));
		navigate(getRoutePathForModel(paramData.workflowStep));
	}
};

export const lastUpdatedElement = (res: any) => (
	<Grid
		item
		xs={6}
		sm={6}
		md={6}
		lg={6}
		xl={6}
		className={styles['conatiner-style']}
	>
		<Typography className={styles['date-style']}>
			{toSentenceCase('Last Updated')}:{' '}
			{dateInCorrectFormatWithFullYear(res.lastUpdated)}
		</Typography>
	</Grid>
);

export const noDataElement = () => (
	<Grid item xs={12} className={`${styles['ai-card-no-content']}`}>
		<Typography>{toSentenceCase(NO_DATA_FOUND)}</Typography>
	</Grid>
);
